import React from 'react';
import { MenuItem, TextField } from '@mui/material';

import { textFieldStyle } from '../../utils/consts/styles';

export const LANGUAGE_LEVELS = ['Нулевой', 'A1', 'A2', 'B1', 'B2', 'C1'];

/**
 * Уровень владения русским языком в карточке слушателя (требование по вопросу О-2).
 *
 * Поля остаются внутри формы карточки, а не уезжают в модалку журнала: это данные
 * слушателя, они сохраняются вместе с остальной карточкой и подчиняются её режиму
 * редактирования. В журнал вынесено только то, что к карточке не относится, —
 * группы и посещаемость.
 *
 * Оформление скопировано у соседних полей карточки: та же ширина 325px, `color="warning"`
 * и `textFieldStyle`, иначе блок выбивается из колонки.
 */
export const LanguageLevelFields = ({ studentData = {}, editMode }) => (
  <>
    <TextField
      select label="Уровень языка" name="language_level"
      defaultValue={studentData.language_level || ''}
      variant="outlined" color="warning" margin="normal" size="small"
      sx={{ width: '325px' }} disabled={editMode}
      inputProps={textFieldStyle} InputLabelProps={textFieldStyle}
    >
      <MenuItem value="">Не определён</MenuItem>
      {LANGUAGE_LEVELS.map((level) => (
        <MenuItem key={level} value={level}>{level}</MenuItem>
      ))}
    </TextField>

    <TextField
      label="Дата тестирования" name="language_level_date" type="date"
      defaultValue={studentData.language_level_date
        ? String(studentData.language_level_date).slice(0, 10)
        : ''}
      variant="outlined" color="warning" margin="normal" size="small"
      sx={{ width: '325px' }} disabled={editMode}
      inputProps={textFieldStyle} InputLabelProps={{ ...textFieldStyle, shrink: true }}
    />

    <TextField
      label="Комментарий по уровню" name="language_level_comment"
      defaultValue={studentData.language_level_comment || ''}
      variant="outlined" color="warning" margin="normal" size="small"
      sx={{ width: '325px' }} disabled={editMode} multiline rows={2}
      inputProps={textFieldStyle} InputLabelProps={textFieldStyle}
    />
  </>
);

export default LanguageLevelFields;
